<div class="cet-container">
  <ng-container *ngFor="let noti of notificationList">
    <div
      class="cet-notification cet-success"
      *ngIf="noti.type == 'success'"
      @slideIn
    >
      <img src="assets/images/valid.svg" alt="success message" />
      <span>{{ noti.text }}</span>
      <img
        src="assets/images/close.svg"
        alt="close the message"
        (click)="hide(noti.id)"
      />
    </div>
    <div class="cet-notification cet-info" *ngIf="noti.type == 'info'" @slideIn>
      <img src="assets/images/info.svg" alt="info message" />
      <span>{{ noti.text }}</span>
      <img
        src="assets/images/close.svg"
        alt="close the message"
        (click)="hide(noti.id)"
      />
    </div>
    <div
      class="cet-notification cet-warning"
      *ngIf="noti.type == 'warning'"
      @slideIn
    >
      <img src="assets/images/warn.svg" alt="warn message" />
      <span>{{ noti.text }}</span>
      <img
        src="assets/images/close.svg"
        alt="close the message"
        (click)="hide(noti.id)"
      />
    </div>
    <div
      class="cet-notification cet-danger"
      *ngIf="noti.type == 'error'"
      @slideIn
    >
      <img src="assets/images/error.svg" alt="error message" />
      <span>{{ noti.text }}</span>
      <img
        src="assets/images/close.svg"
        alt="close the message"
        (click)="hide(noti.id)"
      />
    </div>
  </ng-container>
</div>
